<template>
    <div class="dialog">
        <van-overlay :show="show" @click="hideDialog" :z-index="2100">
            <div class="dialog-wrapper">
                <div class="dialog-content">
                    <img src="@/assets/images/warn.png" alt />
                    <div v-html="content"></div>
                </div>

                <div class="dialog-wrapper-btn flex justify-between">
                    <van-button v-if="isNeedCancelBtn" class="dialog-wrapper-btn-item" @click="handleLeftBtn" plain
                        color="#009AF3">{{
                                leftBtnText
                        }}</van-button>
                    <van-button class="dialog-wrapper-btn-item button" @click="handleConfirm">{{
                            rightBtnText
                    }}</van-button>
                </div>
            </div>
        </van-overlay>
    </div>
</template>

<script>
export default {
    name: "Dialog",
    props: {
        show: {
            type: Boolean,
            default: false,
        },
        content: {
            type: String,
            default: "",
        },
        leftBtnText: {
            type: String,
            default: "取消",
        },
        isNeedCancelBtn: {
            type: Boolean,
            default: true,
        },
        rightBtnText: {
            type: String,
            default: "确定",
        },
    },
    data() {
        return {};
    },
    methods: {
        handleShowDialog() {
            this.$emit("update:show");
        },
        hideDialog() {
            this.$emit("update:show", false);
        },
        handleLeftBtn() {
            this.$emit("handleLeftBtn");
        },
        handleConfirm() {
            this.$emit("handleConfirm");
        },
    },
};
</script>

<style lang="less" scoped>
.dialog {
    z-index: 2100;

    .button {
        color: #fff;
        background-image: linear-gradient(90deg, #009af3 0%, #00c6ea 100%);
    }

    .dialog-wrapper {
        width: 630px;
        height: 300px;
        background: #ffffff;
        border-radius: 20px;
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        margin: auto;
        word-wrap: break-word;

        .warn-text {
            text-align: center;
            font-size: 28px;
            color: red;
            margin-bottom: 50px;
        }

        .dialog-content {
            display: flex;
            font-size: 32px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #212121;
            padding: 0 28px;
            line-height: 36px;
            margin: 50px 0px 50px 0px;

            img {
                height: 60px;
                width: 60px;

                margin-right: 20px;
            }
        }

        .dialog-wrapper-btn {
            width: 100%;
            padding: 0 32px;

            .dialog-wrapper-btn-item {
                margin: 0 10px;
                flex: 1;
                // width: 260px;
                height: 70px;
                border-radius: 16px;
                font-size: 32px;
            }
        }
    }
}
</style>
